const topOfBookCopy = {
  headingBestBid: 'Best Bid @ ',
  headingBestOffer: 'Best Offer @ ',
  headingSpread: 'Spread',
  warningMessage: "We're unable to render Top-of-Book at this time."
};

export default topOfBookCopy;
